import React from "react";
import { Button as MantineButton } from "@mantine/core";

export interface ButtonProps {
  variant?: "outline" | "disabled" | "validation";
  size?: "xs" | "sm" | "md" | "lg";
  children: React.ReactNode;
  onClick?: () => void;
}

export const Button = ({ ...props }: ButtonProps) => {
  const variant =
    props.variant && props.variant !== "validation" ? props.variant : "filled";
  const size = props.size ?? "md";
  const color = props.variant === "validation" ? "#2f9e44" : "#3C61E3";
  return (
    <MantineButton
      variant={variant}
      style={
        variant === "outline"
          ? {
              borderWidth: "2px",
            }
          : {}
      }
      size={size}
      color={color}
      onClick={props.onClick}
      disabled={variant === "disabled"}
    >
      {props.children}
    </MantineButton>
  );
};
